/**
 * 定义全局 mixins 对象
 */


/*此类用于全局设置*/
function childreValidate(vm) {
    var valid = true;
    for (var i in vm) {
        var obj = vm[i];
        if (obj.hasOwnProperty('Valid_Status__')) {
            if (!obj.Valid_Status__) {
                valid = false;
                if (obj.hasOwnProperty('Valid_ShowMsg__') && obj.Valid_ShowMsg__) {
                    if (obj.hasOwnProperty('Valid_ErrorMsg__') && obj.Valid_ErrorMsg__.length > 0) {
                        //utils.growlWarning(obj.Valid_ErrorMsg__);
                        app.$toast.error(obj.Valid_ErrorMsg__);
                    }
                }
                break;
            }
        }
        if (obj.$children.length > 0) {
            valid = childreValidate(obj.$children);
            if (!valid) {
                valid = false;
                break;
            }
        }
    }
    return valid;
}

/* 全局混合*/
export default {
    data: function () {
        return {};
    },
    mounted: function () {
    },
    computed: {
        isdebug(){
            return this.$route && this.$route.query && this.$route.query.isdebug;
        }
    },
    methods: {
        $superValidate: function (_group) {
            var valid = true;
            for (var i in this.$children) {
                var obj = this.$children[i];
                var group = '';
                if (obj.hasOwnProperty('Valid_Group__')) {
                    group = obj.Valid_Group__;
                }
                if (_group !== undefined && _group.length > 0) {
                    if (_group !== group) {
                        continue;
                    }
                }
                if (obj.hasOwnProperty('Valid_Status__')) {
                    if (!obj.Valid_Status__) {
                        valid = false;
                        if (obj.hasOwnProperty('Valid_ShowMsg__') && obj.Valid_ShowMsg__) {
                            if (obj.hasOwnProperty('Valid_ErrorMsg__') && obj.Valid_ErrorMsg__.length > 0) {
                                //utils.growlWarning(obj.Valid_ErrorMsg__);
                                app.$toast.error(obj.Valid_ErrorMsg__);
                            }
                        }
                        break;
                    }
                }
                if (_group === undefined) {
                    if (obj.$children.length > 0) {
                        valid = childreValidate(obj.$children);
                        if (!valid) {
                            valid = false;
                            break;
                        }
                    }
                }
            }
            return valid;
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/index.js